import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { Pos } from '@shop/const';
import { ShopListItemComponent } from './shop-list-item';

@Component({
  selector: 'sd-shop-list',
  imports: [ShopListItemComponent],
  templateUrl: './shop-list.component.html',
  styleUrls: ['./shop-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShopListComponent {
  readonly shops = input.required<Pos[]>();
  readonly activeShopName = input<string>('');
  readonly showAvailability = input<boolean>(false);

  readonly clickShop = output<string>();

  onClickShop(id: string): void {
    this.clickShop.emit(id);
  }
}
